import {
  WSButton,
  WSButtons,
  WSFormOld,
  WSText,
  WSInputTextarea
} from "@wingspanhq/fe-component-library";
import { MemberWorkFlowStatus } from "@wingspanhq/payments/dist/interfaces";
import { InvoiceRow, PayeeReviewStatus } from "@wingspanhq/wingspan-api-sdk";
import React, { useState } from "react";
import { WSQueryCache } from "@ws-react-query";
import { queriesInvoiceRows, queriesInvoices } from "@query";
import { addNotification } from "../../../../components/Notification/Notification";
import { paymentsService } from "../../../../services/payments";
import { bulkActionFactory } from "../../../../modules/BulkActions";

type Props = {
  data: InvoiceRow[];
  onFinish?(): void;
  onClose: () => void;
};

export const ModalBulkDispute: React.FC<Props> = ({
  data,
  onFinish,
  onClose
}) => {
  const [isUpdating, setIsUpdating] = useState(false);

  let paidItems: string[] = [];

  const bulkDispute = bulkActionFactory({
    onStart: () => {
      setIsUpdating(true);
      paidItems = [];
    },
    action: async (item: InvoiceRow, context?: any) => {
      const disputeComment = context?.disputeComment;
      const invoiceId = item.id;

      if (!invoiceId || item.payeeReviewStatus === PayeeReviewStatus.DISPUTED) {
        return;
      }

      return await paymentsService.invoice.update(invoiceId, {
        member: {
          workflowStatus: MemberWorkFlowStatus.Disputed,
          comment: disputeComment
        }
      });
    },
    onFinish: ({ successItems, failedItems }) => {
      WSQueryCache.invalidateQueries(
        queriesInvoiceRows.searchInvoiceRows.queryKeyBase
      );
      WSQueryCache.invalidateQueries(queriesInvoices.getInvoice.queryKeyBase);

      addNotification({
        timeout: 6000,
        text:
          `${successItems.length} invoice${
            successItems.length > 1 ? "s" : ""
          } have been disputed` +
          (paidItems.length > 0
            ? `, ${paidItems.length} ${
                paidItems.length > 1 ? "were" : "was"
              } already paid`
            : "") +
          (failedItems.length > 0 ? `, ${failedItems.length} failed` : "")
      });

      setIsUpdating(false);
    }
  });

  return (
    <>
      <WSFormOld<{ disputeComment: string }>
        onSubmit={async ({ disputeComment }) => {
          await bulkDispute.run(data, {
            disputeComment
          });
          onFinish?.();
          onClose();
        }}
      >
        <WSText.Heading5 mb="M">
          Dispute {data.length} invoice{data.length > 1 && "s"}?
        </WSText.Heading5>
        <WSText mb="XL">
          Indicate the reason for the dispute in the field below
        </WSText>

        <WSFormOld.Field
          mb="XL"
          name="disputeComment"
          component={WSInputTextarea}
        />

        <WSButtons>
          <WSButton loading={isUpdating}>Dispute</WSButton>
          <WSButton.Secondary onClick={onClose} type="button">
            Cancel
          </WSButton.Secondary>
        </WSButtons>
      </WSFormOld>
    </>
  );
};
